'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import Lockup from 'components/blocks/shared/Lockup';
import ButtonCTA from 'components/ui/ButtonCTA';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import { blockRootProps } from 'utils';
import { addProtocol } from 'utils/url';

import RichHeadline from './RichHeadline';

import styles from './BlockTwoColumnImage.module.scss';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    baseTheme="bodySmall"
                    themes={{ large: 'bodyMedium' }}
                >
                    {children}
                </Text>
            );
        },
        [BLOCKS.UL_LIST]: (node, children) => {
            return <ul className={styles.richUnorderedList}>{children}</ul>;
        },
    },
};

const BlockTwoColumnImage = ({
    __typename,
    anchorId,
    eyebrow,
    headline,
    richHeadline,
    bodyCopy,
    richText,
    theme,
    leftImage,
    className,
    image,
    cta,
    ctas,
    icon,
    flushTop,
    flushBottom,
    backgroundColor,
}) => {
    backgroundColor ??= 'creamDark';

    console.log(addProtocol(image.url));

    return (
        <article
            {...blockRootProps(anchorId, __typename)}
            style={{ backgroundColor: `var(--colors-${backgroundColor})` }}
            className={cx(styles.blockTwoColumnFlex, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <div
                className={cx(
                    styles.blockTwoColumn,
                    className,
                    styles[`theme--${theme}`],
                    {
                        [styles.blockTwoColumnReversed]: leftImage,
                    }
                )}
            >
                <div className={styles.column}>
                    {image?.url && (
                        <NextImage
                            className={styles.image}
                            src={addProtocol(image.url)}
                            width={image.width}
                            height={image.height}
                            sizes="(max-width: 768px) 100vw, 50vw"
                            alt={image.description || ''}
                        />
                    )}
                </div>
                <div className={styles.column}>
                    <div className={styles.lockup}>
                        <Lockup
                            icon={icon}
                            eyebrow={{ text: eyebrow }}
                            theme="Medium"
                        />
                        {headline && !richHeadline && (
                            <div className={styles.headline}>
                                <Text
                                    baseTheme="displayXSmall"
                                    themes={{
                                        large: 'displayMedium',
                                    }}
                                >
                                    {headline}
                                </Text>
                            </div>
                        )}
                        {richHeadline && (
                            <div className={styles.richHeadline}>
                                <RichHeadline richText={richHeadline} />
                            </div>
                        )}
                        {bodyCopy && !richText && (
                            <div className={styles.copy}>
                                <Text
                                    baseTheme="bodySmall"
                                    themes={{
                                        large: 'bodyMedium',
                                    }}
                                    fixWidows
                                >
                                    {bodyCopy}
                                </Text>
                            </div>
                        )}
                        {richText && (
                            <div className={styles.copy}>
                                <RichText
                                    richText={richText}
                                    overrides={richTextOverrides}
                                />
                            </div>
                        )}
                        <div
                            className={cx(styles.buttonWrapper, {
                                [styles.multiButton]: ctas?.length,
                            })}
                        >
                            {ctas?.length ? (
                                <>
                                    {ctas?.map((cta, idx) => (
                                        <ButtonCTA
                                            key={idx}
                                            className={styles.cta}
                                            {...cta}
                                        />
                                    ))}
                                </>
                            ) : (
                                <>
                                    {cta && (
                                        <ButtonCTA
                                            className={styles.cta}
                                            {...cta}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
};

BlockTwoColumnImage.propTypes = {
    __typename: PropTypes.string,
    eyebrow: PropTypes.string,
    anchorId: PropTypes.string,
    backgroundColor: PropTypes.string,
    bodyCopy: PropTypes.string,
    className: PropTypes.string,
    cta: PropTypes.shape({
        __typename: PropTypes.string,
        assetDownloadLink: PropTypes.object,
        cta: PropTypes.shape({
            text: PropTypes.string,
        }),
        link: PropTypes.object,
        text: PropTypes.string,
    }),
    ctas: PropTypes.array,
    icon: PropTypes.shape({
        icon: PropTypes.shape({
            url: PropTypes.string,
        }),
    }),
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    headline: PropTypes.string,
    image: PropTypes.object,
    leftImage: PropTypes.bool,
    richHeadline: PropTypes.object,
    richText: PropTypes.object,
    theme: PropTypes.string,
};

export default BlockTwoColumnImage;
